export default [
    {
        path: '/login',
        name: 'Login',
        component: require('./../../views/Auth/Login').default
    },
    // {
    //     path: '/password/reset',
    //     name: 'Password-Reset',
    //     component: require('./../../views/Auth/Password-Reset').default
    // },
    // {
    //     path: '/password/reset/:email/:token',
    //     name: 'Password-Change',
    //     component: require('./../../views/Auth/Password-Change').default,
    // },
]
